import { Http } from '../../common/api';
import { KnowledgeBaseApiConfiguration } from '../models';

export const knowledgeBaseHttp = new Http();

export const initializeKnowledgeBaseHttp = (config: KnowledgeBaseApiConfiguration): void => {
  knowledgeBaseHttp.initializeHttp(config.baseUrl);
};

export const isKnowledgeBaseApiConfigured = (): boolean => {
  return knowledgeBaseHttp.isReady();
};
